export const modalMixins = {
  data() {
    return {
      okTitle: 'Save',
      isModalTableBusy: false,
      buttonLabel: 'Save',
      isReadonly: false,
      isLoading: false,
      recordCount: 0,
      page: 10,
      pageSize: 0,
      current: 1,
      perPageOptions: [10, 25, 50, 100],
    }
  },
  computed: {
    totalModalEntries() {
      return this.recordCount
    },
    pageNumber() {
      return Math.floor((this.totalModalEntries + this.page - 1) / this.page)
    },
    modalFrom() {
      return (this.current * this.page) - (this.page - 1)
    },
    modalTo() {
      return Math.min(this.modalFrom + this.page - 1, this.totalModalEntries)
    },
  },
  methods: {
    showModal(id) {
      this.$bvModal.show(id)
    },
    hideModal(id) {
      this.$bvModal.hide(id)
    },
  },
}

export const _ = null
